import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    radioSelectGroup: {
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& h6': {
            marginBottom: theme.spacing(2),
        }, 
    },
    downloadTemplateBtn: {
        textAlign: 'left',
        width: 210,
        boxShadow: 'none',
        justifyContent: 'left',
        marginTop: theme.spacing(1),
        marginBottom: '24px !important',
        color: '#999 !important',
        padding: '6px 8px !important'
    },
    fileSelectDropDown: {
        width: '200px !important',
        marginTop: theme.spacing(1),
        marginBottom: '8px !important',
        '& .MuiInputBase-input.Mui-disabled': {
            border: '1px solid #ddd',
        },
        '& .MuiSelect-outlined': {
            borderRadius: '24px !important',
        }
    },
    oneDropDown: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        '& p': {
            marginBottom: '8px !important'
        }
    },
    orientationSelect: {
        '& .MuiFormControlLabel-root': {
            alignItems: 'baseline'
        }
    },
    labelText: {
        marginTop: 0,
        position: 'relative',
        top: -6,
    }
}));

export default useStyles;